// Defining and Exporting constant data to be used in all insurance forms

export const INPUT_RADIO_OFFICIAL_RULES = ['Yes', 'No']
export const INPUT_RADIO_MARITAL_STATUS = ['Single', 'Married', 'Divorced', 'Widowed']
export const INPUT_RADIO_GENDER = ['Male', 'Female']
export const INPUT_RADIO_TITLE = ['Miss', 'Ms', 'Mrs', 'Mr']
export const INPUT_RADIO_TYPE_HOME = ['Apartment', 'House', 'Villa']
export const INPUT_RADIO_OWNERSHIP_STATUS = ['Owner', 'Tenant']
export const INPUT_RADIO_TYPE_COVER = ['Content Only', 'Building Only', 'Content & Building', 'Other']
export const INPUT_CHECKBOX_USAGE = ['Business', 'Pleasure', 'Carpool', 'Other']



// WEBPACK FOOTER //
// ./src/data/forms.js